import { Table } from "@/components";
import { formatDate, ImgSrc } from "@/utils";
import { ReportOutlined } from "@mui/icons-material";
import { Avatar, Stack, Typography } from "@mui/material";
import { red } from "@mui/material/colors";
import { FC, useState } from "react";
import { Loading } from "react-admin";
import { useNavigate, useParams } from "react-router-dom";
import { useGetUserReports } from "../../queries";

const ROWS_PER_PAGE = 5;

const UserReports: FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { reports, isPending, fetchNextPage } = useGetUserReports({
    page,
    userId: id,
    perPage: ROWS_PER_PAGE,
  });

  const onPageChange = async (newPage: number) => {
    await fetchNextPage();
    setPage(newPage);
  };

  if (!reports || !reports.meta.total) {
    return null;
  }
  if (isPending) {
    return <Loading />;
  }
  return (
    <Stack width={"100%"}>
      <Stack p={2}>
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <Typography variant="h6">Reports</Typography>
          <ReportOutlined sx={{ color: red[800] }} />
        </Stack>
        <Typography variant="caption" color="grey">
          {reports.meta.total} results
        </Typography>
      </Stack>

      <Table
        page={page}
        rowsPerPage={ROWS_PER_PAGE}
        rowsPerPageOptions={[]}
        headCells={["Reported By", "Report Date", "Description / Type"]}
        count={reports.meta.total}
        onPageChange={onPageChange}
        bodyCells={reports.data.map(
          ({ reportedBy, createdAt, description, type }) => [
            <Stack
              direction={"row"}
              spacing={2}
              sx={{ cursor: "pointer" }}
              alignItems={"center"}
              onClick={() =>
                navigate(`/users/${reportedBy.id}/show`, {
                  state: { _scrollToTop: true },
                })
              }
            >
              <Avatar
                alt="avatar"
                src={ImgSrc(reportedBy?.profileImage?.path ?? "")}
                sx={{ height: 32, width: 32 }}
              />
              <Typography component="span" variant="body2">
                {`${reportedBy.firstName} ${reportedBy.lastName}`}
              </Typography>
            </Stack>,
            formatDate(createdAt),
            description ?? type,
          ]
        )}
      />
    </Stack>
  );
};

export { UserReports };
